import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const shots = [
  {
    url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_smooth-spirits/artifacts/lpigdwzn_IMG_2626.webp",
    label: "Craft on Ice",
    size: "md:col-span-7 h-[380px] md:h-[520px]",
    pos: "object-center",
  },
  {
    url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_smooth-spirits/artifacts/xv90rylc_IMG_2625.webp",
    label: "The Signature Pour",
    size: "md:col-span-5 h-[380px] md:h-[520px]",
    pos: "object-top",
  },
  {
    url: "https://images.unsplash.com/photo-1767745455688-49391131f751",
    label: "Flight of Three",
    size: "md:col-span-5 h-[360px] md:h-[460px]",
    pos: "object-center",
  },
  {
    url: "https://images.pexels.com/photos/36189454/pexels-photo-36189454.jpeg",
    label: "Frothed & Finished",
    size: "md:col-span-7 h-[360px] md:h-[460px]",
    pos: "object-center",
  },
];

function Frame({ shot }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.25, 1]);

  return (
    <Reveal className={shot.size}>
      <div ref={ref} className="group relative w-full h-full overflow-hidden bg-[#0a0a0a] border border-[#222]">
        <motion.img
          style={{ scale }}
          src={shot.url}
          alt={shot.label}
          className={`w-full h-full object-cover ${shot.pos} grayscale-[0.15] group-hover:grayscale-0 transition-all duration-700`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80" />
        <div className="absolute bottom-5 left-5 flex items-center gap-3">
          <span className="h-px w-8 bg-gold" />
          <span className="text-xs uppercase tracking-[0.25em] text-white/90">{shot.label}</span>
        </div>
      </div>
    </Reveal>
  );
}

export default function Gallery() {
  return (
    <section id="gallery" className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto" data-testid="gallery-section">
      <Reveal className="mb-14">
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">The Look</p>
        <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl tracking-tight leading-none">
          A gallery of <span className="italic gold-shimmer">good taste.</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
        {shots.map((s) => (
          <Frame key={s.label} shot={s} />
        ))}
      </div>
    </section>
  );
}
